
<script>
  import { Line , mixins } from "vue-chartjs";
  export default {
    mixins: [mixins.reactiveData, mixins.reactiveProp],
    extends: Line,
    props: {
      chartData: {
        type: Array | Object,
        required: false
      },
       chartAbastible: {
        type: Array | Object,
        required: false
      },
       chartLipigas: {
        type: Array | Object,
        required: false
      },
      chartLabels: {
        type: Array,
        required: true
      },
      chartDetail: {
        type: Array | Object,
        required: false
      },
    },
    data () {
      return {
        options: {
          scales: {
            yAxes: [{
              ticks: {
                 beginAtZero: true,
                  callback: (value, index, values) => {
                  if (parseInt(value) >= 1000) {
                     return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  } else {
                     return '$' + value;
                  }
               }
              },
              gridLines: {
                display: true
              }
            }],
            xAxes: [ {
              gridLines: {
                display: false
              }
            }]
          } ,
          tooltips: {
            
            callbacks: {
             // title: tooltipItem => {
             //   return `🗓 ${tooltipItem[0].xLabel}`
             // },
              label: (t, d) => {
                //debugger;
                 var xLabel = d.datasets[t.datasetIndex].label;
                  var yLabel = t.yLabel >= 1000 ? '$' + t.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : '$' + t.yLabel;
                  return xLabel + ': ' + yLabel;
              }
            }
          },
          legend: {
            display: true
          },
          responsive: true,
          maintainAspectRatio: false
        }
      }
    },
    mounted () {
      this.renderChart({
        labels: this.chartLabels,
        datasets: [
          {
            label: 'Gasco',
            borderColor: '#0D47A1',
            pointBackgroundColor: '#0D47A1',
            borderWidth: 1,
            pointBorderColor: '#0D47A1',
            backgroundColor: '#0D47A1',
            fill: false,
            data: this.chartData,
            lineTension: 0.1,
          },
           {
            label: 'Abastible',
            borderColor: '#FF9800',
            pointBackgroundColor: '#FF9800',
            borderWidth: 1,
            pointBorderColor: '#FF9800',
            backgroundColor: '#FF9800',
            fill: false,
            data: this.chartAbastible,
            lineTension: 0.1,
          },
           {
            label: 'Lipigas',
            borderColor: '#ffc107',
            pointBackgroundColor: '#ffc107',
            borderWidth: 1,
            pointBorderColor: '#ffc107',
            backgroundColor: '#ffc107',
            fill: false,
            data: this.chartLipigas,
            lineTension: 0.1,
          }
        ],
        
      }, this.options)
    },
     watch: {
    data: function() {
      this._chart.destroy();
      //this.renderChart(this.data, this.options);
       this.renderChart({
        labels: this.chartLabels,
        datasets: [
          {
            label: 'Gasco',
            borderColor: '#0D47A1',
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: '#0D47A1',
            backgroundColor: '#0D47A1',
            data: this.chartData
          },
           {
            label: 'Abastible',
            borderColor: '#FF9800',
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: '#FF9800',
            backgroundColor: '#FF9800',
            data: this.chartAbastible
          },
           {
            label: 'Lipigas',
            borderColor: '#FFFF00',
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: '#FFFF00',
            backgroundColor: '#FFFF00',
            data: this.chartLipigas
          }
        ]
      }, this.options)
    }
  }
  }
</script>
 